import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'
import uniqid from 'uniqid';

const DEFAULT_COUNTRY = { iso2: "DE", iso3: "DEU", name: "Deutschland", vat: 19, language: "de", storeCode: "de" };

export const useCustomerStore = create()(
  persist(
    (set, get) => ({ 
      token: null,
      uniqueId: null,
      isLoggedIn: false,
      firstname: null,
      lastname: null,
      addresses: [],
      email: null,
      phone: null,
      password: null,
      country: DEFAULT_COUNTRY,
      vin: null,
      gender: null,
      dob: null,
      group_id: null,
      taxvat: null,
      created_at: null,
      taxFree: false,

      ensureUniqueId: () => {
        if (!get().uniqueId) set({ uniqueId: uniqid('guest_') });
        return get().uniqueId;
      },

      setTaxFree: (value) => set({ taxFree: value }),
      setVin: (newVin) => set({ vin: newVin }),

      setToken: (newToken) => set({ token: newToken, isLoggedIn: true }),
      unsetToken: () => set({ token: null, isLoggedIn: false }),
      setEmail: (newEmail) => set({ email: newEmail }),
      setCountry: (newCountry) => set({ country: newCountry }),
      getAddresses: () => get().addresses,  
      getCustomerData: () => ({
        uniqueId: get().uniqueId,
        email: get().email,
        firstname: get().firstname,
        lastname: get().lastname,
        addresses: get().addresses,
        gender: get().gender,
        dob: get().dob,
        phone: get().phone,
        isLoggedIn: get().isLoggedIn,
        country: get().country,
        taxFree: get().taxFree,
        vin: get().vin,
        group_id: get().group_id,
        taxvat: get().taxvat,
        created_at: get().created_at,
      }),
      setCustomerData: (data) => set({
        uniqueId: data?.uniqueId ?? get().uniqueId,
        email: data?.email ?? get().email,
        password: data?.password ?? get().password,
        firstname: data?.firstname ?? get().firstname,
        lastname: data?.lastname ?? get().lastname,
        addresses: data?.addresses ?? get().addresses,
        phone: data?.phone ?? get().phone,
        isLoggedIn: true,
        country: data?.country ?? get().country,
        taxFree: data?.taxFree ?? get().taxFree,
      }),

      resetUserData: () => set({
        token: null,
        isLoggedIn: false,
        firstname: null,
        lastname: null,
        addresses: [],
        email: null,
        phone: null,
        password: null,
        country: DEFAULT_COUNTRY,
        vin: null,
        gender: null,
        dob: null,
        group_id: null,
        taxvat: null,
        created_at: null,
        taxFree: false,
      }),
    }),
    {
      name: 'current-user',
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);
